import { Select } from "./../components/select/index";
export enum ManageUser {
  List = "View Users",
  Create = "Add User",
  Update = "Edit User",
  UpdateUserPermissions = "Edit User Permissions",
  Deactivate = "Deactivate User",
  Archive = "Archive User",
  Delete = "Delete User",
  Select = "Select Users",
  ResetPassword = "Reset User Password",
}
export enum ManageRoles {
  List = "View Roles",
  Update = "Edit Role Permissions",
  Create = "Create Role",
  Delete = "Delete Role",
}
export enum ManagePermissions {
  List = "View Permissions",
}
export enum ManagePermissionCategory {
  List = "View Permissions Categories",
}
export enum ManageTestQuestion {
  List = "View Questions",
  Create = "Add Question",
  Update = "Edit Question",
  Delete = "Delete Question",
  Details = "View Question Details",
}
export enum ManageMonitoring {
  ViewReports = "View Reports",
  ViewLog = "View Log",
}
export enum ManageCompany {
  List = "View Company",
  Details = "View Company Details",
  Create = "Add Company",
  Update = "Update Company",
  Delete = "Delete Company",
  Select = "Select Company",
}
export enum ManageAgentCompany {
  List = "View Agent Companies",
  Details = "View Agent Company Details",
  Create = "Add Agent Company",
  Update = "Update Agent Company",
  Delete = "Delete Agent Company",
}
export enum ManageDoctorInvitation {
  Invite = "Invite Doctor",
  View = "View Doctor Invitations",
  Cancel = "Cancel Doctor Invitation",
  UpdateDoctorAgentCompany = "Update Doctor Agent Company",
}
export enum ManagePatients {
  List = "View Patients",
  ViewOwnListOfPatients = "View Own List Of Patients",
  ViewOnGoingPatients = "View On Going Patients",
  Create = "Add Patient",
  Update = "Update Patient",
}
export enum ManageTreatments {
  List = "View Treatments",
  ActionNeededTreatments = "View Action Needed Treatments",
  ViewOnGoingTreatments = "View On Going Treatments",
  ArchivedTreatments = "View Archived Treatments",
  Details = "View Treatment Details",
  AddTreatmentToPatient = "Add Treatment To Patient",
  Delete = "Delete Treatment",
}

export enum ManageAccount {
  SetNewPassword = "Set New Password",
  ChangeTemporaryPassword = "Change Temporary Password",
}

export enum ManagePackages {
  List = "View Package",
  Create = "Create Package",
  Update = "Update Package",
  Delete = "Delete Package",
  TogglePackageActivation = "Toggle Package Activation",
}

export enum ManageCodes {
  List = "View Codes",
  Create = "Add Code",
  Update = "Update Code",
  Delete = "Delete Code",
}

export enum ManageCases {
  List = "View Cases",
  AddCaseToPatient = "Add Case To Patient",
  ActionNeededCases = "View Action Needed Cases",
  ViewOnGoingCases = "View On Going Cases",
  ArchivedCases = "View Archived Cases",
  Details = "View Case Details",
  Delete = "Delete Case",
}

export enum ManageCasePricing {
  List = "View Case Pricing",
  Details = "View Case Pricing Details",
  Create = "Add Case Pricing",
  Update = "Update Case Pricing",
  Delete = "Delete Case Pricing",
  Select = "Select Case Pricing",
}
export enum ManageCaseTreatmentMaterial {
  List = "View Materials",
  Details = "View Material Details",
  Create = "Add Material",
  Update = "Update Material",
  Delete = "Delete Material",
  Select = "Select Material",
}
export enum ManageTreatmentColor {
  List = "View Treatment Colors",
  Details = "View Treatment Color Details",
  Create = "Add Treatment Color",
  Update = "Update Treatment Color",
  Delete = "Delete Treatment Color",
  Select = "Select Treatment Color",
}
export enum ManageTreatmentType {
  List = "View Restoration Type",
  Details = "View Restoration Type Details",
  Create = "Add Restoration Type",
  Update = "Update Restoration Type",
  Delete = "Delete Restoration Type",
  Select = "Select Restoration Type",
}

export enum ManagePriceBrackets {
  List = "View Price Brackets",
  Create = "Add Price Bracket",
  Update = "Update Price Bracket",
  Delete = "Delete Price Bracket",
}

export enum ManageChat {
  VIEW = "View Chat",
}

export enum ManageCashPayment {
  View = "View Cash Payment Report",
  ConfirmAsAgentCompany = "Confirm Cash Payment As Agent Company",
  ConfirmAsAdmin = "Confirm Cash Payment As Admin",
}

export enum ManageDoctorStatistics {
  View = "View Doctor Statistics",
}

export enum ManagePlannerStatistics {
  View = "View Planner Statistics",
}

export enum ManageFabricatorStatistics {
  View = "View Fabricator Statistics",
}

export enum ManageCoordinatorStatistics {
  View = "View Coordinator Statistics",
}
